module.exports = __webpack_public_path__ + "img/home_banner01.14c58388.jpg";